var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.059 12.422a.447.447 0 0 1 .117.424l-.4 1.598a.447.447 0 0 0 .656.496l1.37-.784a.446.446 0 0 1 .443 0l1.37.784a.446.446 0 0 0 .655-.496l-.4-1.598a.447.447 0 0 1 .118-.424l.845-.846a.447.447 0 0 0-.316-.762H17.39a.447.447 0 0 1-.41-.27l-.545-1.273a.446.446 0 0 0-.821 0l-.545 1.272a.447.447 0 0 1-.41.271H13.53a.447.447 0 0 0-.316.762zM6.75 24.75h18.5v1.5H6.75z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.19 11.25h-6.07a6.246 6.246 0 0 0-12.24 0H3.81a1.562 1.562 0 0 0-1.56 1.56v15.38a1.562 1.562 0 0 0 1.56 1.56h24.38a1.562 1.562 0 0 0 1.56-1.56V12.81a1.562 1.562 0 0 0-1.56-1.56zM24 20.5a1 1 0 1 1-1 1 1.003 1.003 0 0 1 1-1zm-12 0a1 1 0 1 1-1 1 1.003 1.003 0 0 1 1-1zm4 0a1 1 0 1 1-1 1 1.003 1.003 0 0 1 1-1zm4 0a1 1 0 1 1-1 1 1.003 1.003 0 0 1 1-1zM16 7.75a4.76 4.76 0 1 1-4.58 3.5A4.746 4.746 0 0 1 16 7.75zM8 20.5a1 1 0 1 1-1 1 1.003 1.003 0 0 1 1-1zM26.75 27a.755.755 0 0 1-.75.75H6a.756.756 0 0 1-.75-.75v-3a.756.756 0 0 1 .75-.75h20a.755.755 0 0 1 .75.75zM15.25 3v1.5a.75.75 0 0 0 1.5 0V3a.75.75 0 0 0-1.5 0zM10.625 3.69a.75.75 0 0 0-.274 1.025l.75 1.299a.75.75 0 1 0 1.298-.75l-.75-1.3a.75.75 0 0 0-1.024-.274z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.715 7.35a.75.75 0 0 0-.75 1.3l1.299.75a.75.75 0 1 0 .75-1.3zM20.35 3.965l-.75 1.299a.75.75 0 1 0 1.3.75l.75-1.3a.75.75 0 0 0-1.3-.75zM24.285 7.35l-1.299.75a.75.75 0 1 0 .75 1.3l1.3-.75a.75.75 0 1 0-.75-1.3z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerClub);
export default __webpack_public_path__ + "static/media/CustomerClub.f55f250e181e5930c54f71744fefed08.svg";
export { ForwardRef as ReactComponent };